export default function CsharpMultilineComments() {
  return (
    <h2>Csharp MultiLine Comments</h2>
  );
}
